module.exports = __webpack_public_path__ + "img/actions.fc4e8b90.svg";